<div class="auth-form" [class.auth-form--parent]="isParentLayout()">
  <form [formGroup]="signupForm">
    <mat-horizontal-stepper linear #signupStepper>
      <mat-step [completed]="profileStepValid()">
        <ng-template matStepLabel>
          {{ 'app.auth.profileDetails' | translate }}
        </ng-template>

        <app-input-field
          formControlName="firstName"
          [label]="'app.auth.firstName' | translate"
          [inputType]="'input'"
          [type]="'text'"
          [validationErrors]="firstNameValidation()"
        />

        <app-input-field
          formControlName="lastName"
          [label]="'app.auth.lastName' | translate"
          [inputType]="'input'"
          [type]="'text'"
          [validationErrors]="lastNameValidation()"
        />

        <app-input-field
          formControlName="country"
          [label]="'app.auth.country' | translate"
          [inputType]="'select'"
          [type]="'text'"
          [validationErrors]="countryValidation()"
          [options]="countries()"
        />

        <app-input-field
          formControlName="email"
          [label]="'app.auth.email' | translate"
          [inputType]="'input'"
          [type]="'email'"
          [autocomplete]="'email'"
          [validationErrors]="emailValidation()"
        />

        <div class="auth-form__cta">
          @if (isParentLayout()) {
            <app-parent-button
              [fullWidth]="true"
              [disabled]="!profileStepValid()"
              (clicked)="goToCredentialsStep()"
            >
              {{ 'app.auth.next' | translate }}
            </app-parent-button>
          } @else {
            <app-cta-button
              size="small"
              [disabled]="!profileStepValid()"
              [loading]="false"
              (clicked)="goToCredentialsStep()"
            >
              <span cta-label>{{ 'app.auth.next' | translate }}</span>
            </app-cta-button>
          }
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>
          {{ 'app.auth.credentials' | translate }}
        </ng-template>

        <app-input-field
          formControlName="userName"
          [label]="'app.auth.userName' | translate"
          [inputType]="'input'"
          [type]="'text'"
          [autocomplete]="'username'"
          [validationErrors]="userNameValidation()"
        />

        <app-input-field
          formControlName="password"
          [label]="'app.auth.password' | translate"
          [inputType]="'input'"
          [type]="'password'"
          [autocomplete]="'new-password'"
          [validationErrors]="passwordValidation()"
          [showPwdComplexity]="true"
        />

        <div class="auth-form__cta auth-form__cta--stacked">
          @if (isParentLayout()) {
            <app-parent-button variant="icon" (clicked)="goBackToProfileStep()">
              <img src="/public/svgs/arrow-left.svg" alt="" width="16" height="16" />
            </app-parent-button>
            <app-parent-button
              [fullWidth]="true"
              [disabled]="!signupForm.valid || isLoading()"
              [loading]="isLoading()"
              (clicked)="onSubmit()"
            >
              {{ 'app.auth.createAccount' | translate }}
            </app-parent-button>
          } @else {
            <app-cta-button
              size="small"
              [variant]="'round'"
              (clicked)="goBackToProfileStep()"
            >
              <img cta-postfix src="/public/svgs/arrow-left.svg" alt="back" />
            </app-cta-button>

            <app-cta-button
              size="small"
              class="full-width"
              [disabled]="!signupForm.valid || isLoading()"
              [loading]="isLoading()"
              (clicked)="onSubmit()"
            >
              <span cta-label>{{ 'app.auth.createAccount' | translate }}</span>
            </app-cta-button>
          }
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</div>
